import React from 'react';
import { AND, COND, OP, OR, SEPARATOR } from "../../misc/RuleObjectTypes";
import { useContext, useEffect, useState } from "react";
import SubCondition from "./SubCondition";
import { RulesContext } from "../../RulesContext";
import { AddIconWithBorder } from 'assests/GmsIcons';

const NestedCondition = ({ element, rootPosition }) => {
  const { ruleDispatch } = useContext(RulesContext);
  function groupConditions(arr, rootPosition) {
    let renderArr = arr.map((element, index) => {
      if (Array.isArray(element)) {
        return groupConditions(element, `${rootPosition}${SEPARATOR}${index}`);
      }
      switch (element.type) {
        case OP:
          return (
            <SubConditionOperator
              key={index}
              {...{
                element,
                position: element.position,
              }}
            />
          );
        case COND:
          return (
            <SubCondition
              key={index}
              {...{
                element,
                position: element.position,
              }}
            />
          );
        default:
          return null;
      }
    });
    return (
      <div className="condition-wrapper ms-0" key={rootPosition}>
        <div className="left-nesting-bracket" />
        <div>
          {renderArr.map((element) => {
            return element;
          })}
        </div>
        <div className="right-nesting-bracket" />
      </div>
    );
  }
  return (
    <div className="tw-border tw-border-[#E4E4E8] tw-rounded-md tw-bg-[#FAFAFC]">
      <div className="">
        {groupConditions(element, rootPosition)}
        {/* <i
          onClick={() =>
            ruleDispatch({
              type: "ADD_SUBCONDITION",
              position: rootPosition,
            })
          }
          className="fa fa-plus-circle ms-4"
          style={{ color: "rgb(9, 28, 170)", fontSize: "1.6em" }}
        /> */}

        <button
          className="tw-flex tw-items-center tw-text-sm tw-gap-1 tw-px-2 tw-py-1 tw-mx-3 tw-text-[#0747A6] tw-rounded-md hover:tw-bg-blue-50"
          onClick={() =>
            ruleDispatch({
              type: "ADD_SUBCONDITION",
              position: rootPosition,
            })
          }
        >
          <AddIconWithBorder />
          <span className="tw-text-[#0747A6] tw-text-sm">Add Condition</span>
        </button>
        {/* <button
          className="mt-1 mb-2 add-logic-filter-button ms-4"
          style={{ fontSize: "0.8rem" }}
          onClick={() =>
            ruleDispatch({
              type: "ADD_SUBCONDITION",
              position: rootPosition,
            })
          }
        >
          ADD LOGIC
        </button> */}
      </div>
      <div className="separator" />
    </div>
  );
};
export default NestedCondition;

const SubConditionOperator = ({ element, position }) => {
  const { ruleDispatch } = useContext(RulesContext);
  const [subConditionOp, setSubConditionOp] = useState(AND);
  useEffect(() => {
    setSubConditionOp(element.subConditionOp);
  });

  return (
    <div className="sub-condition-operator">
      <select
        className='form-select drop-down-dm tw-w-[7%] shadow-none tw-border tw-border-[#E4E4E8] tw-bg-white tw-rounded tw-font-medium tw-text-sm tw-text-[#747593] tw-px-2 tw-py-1'
        value={subConditionOp}
        onChange={(el) =>
          ruleDispatch({
            type: "SET_COND_OP",
            subConditionOp: el.target.value,
            position: position,
          })
        }
      >
        <option value={AND}>And</option>
        <option value={OR}>Or</option>
      </select>
    </div>
  );
};
